import { LOCALE_ID as Provide, Provider } from '@angular/core';

export const Value = 'es-AR';
export const LocaleIDProvider: Provider = {
  provide: Provide,
  useValue: Value,
};
